'use client';

import { Text } from '../components/text';
import { Collapsible } from '../components/collapsible';
import type { ButtonProps } from '../components/button';
import { Button } from '../components/button';
import { HStack, Box } from '@terra/ui-styled-system';
import { ArrowDown01Icon, ArrowRight01Icon } from '@terra/ui-icons';

export const EnhancedCollapsibleWrapper = ({
  children,
  open,
  onOpenChange,
  triggerIcon,
  triggerContent,
  triggerSize = 'sm',
  colorScheme = 'gray',
  lazyMount = true,
  unmountOnExit = true,
}: {
  children: React.ReactNode;
  open: boolean;
  onOpenChange: (open: boolean) => void;
  triggerIcon: React.ReactNode;
  triggerSize?: ButtonProps['size'];
  triggerContent: React.ReactNode;
  colorScheme?: string;
  lazyMount?: boolean;
  unmountOnExit?: boolean;
}) => {
  return (
    <Collapsible.Root
      lazyMount={lazyMount}
      unmountOnExit={unmountOnExit}
      open={open}
      onOpenChange={({ open }) => onOpenChange(open)}
    >
      <Collapsible.Trigger asChild>
        <Button
          size={triggerSize}
          variant="ghost"
          colorScheme={colorScheme}
          fontWeight="semibold"
          justifyContent="flex-start"
          w="full"
        >
          <HStack gap={2} w="full" justifyContent="space-between">
            <HStack gap={2} w="full">
              {triggerIcon}
              {typeof triggerContent === 'string' ? (
                <Text fontSize="xs">{triggerContent}</Text>
              ) : (
                triggerContent
              )}
            </HStack>
            {open ? (
              <ArrowDown01Icon size={14} />
            ) : (
              <ArrowRight01Icon size={14} />
            )}
          </HStack>
        </Button>
      </Collapsible.Trigger>
      <Collapsible.Content>
        <Box width="full" height="full" p={4} borderRadius="md">
          {children}
        </Box>
      </Collapsible.Content>
    </Collapsible.Root>
  );
};
